<template></template>

<script>
// Export the root component as named export.
export const BaseForm = {
  name: "BaseForm"
  // ...
};

// Proxy export all related components.
export { default as textInputBase } from "./basetextinput";
export { default as phoneInputBase } from "./basePhoneInput";
export { default as stateInputBase } from "./baseSelectStateInput";
export { default as emailInputBase } from "./baseEmailInput";
export { default as passwordInputBase } from "./basePasswordInput";
export { default as countryInputBase } from "./baseSelectCountryInput";
export { default as industryInputBase } from "./baseIndustryInput";
export { default as apptypeInputBase } from "./baseAppInput";
export { default as phonecodeInputBase } from "./basePhoneCodeInput";
export { default as numberInputBase } from "./baseNumericInput";
export { default as moneyInputBase } from "./baseMoneyInput";
export { default as percentInputBase } from "./basePercentInput";
export { default as zoneInputBase } from "./baseZoneInput";
export { default as operateInputBase } from "./baseOperateInput";
export { default as typeBusinessInputBase } from "./baseTypeBusinessInput";
export { default as dateInputBase } from "./baseDateinput";
export { default as choicesInputBase } from "./baseYesNoInput";
export { default as transInputBase } from "./baseTransTypeinput";

export { default as crediCardInputBase } from "./baseCreditcard";
export { default as cartInputBase } from "./baseCartInput";
export { default as documentationBase } from "./baseDocumentationform";
export { default as basePasswordResetBase } from "./basePasswordReset";


// A Vue.js SFC must have a default export.
export default BaseForm;
</script>
